export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isNull.js
// module id = 2228
// module chunks = 2